import React from 'react';

function Disclaimer() {
    return (
        <div
            className="min-h-[calc(100vh-2rem)] m-2 sm:m-4 md:m-8 lg:m-12 bg-white border border-gray-200 rounded-2xl shadow-lg flex flex-col justify-center font-[Quicksand] text-gray-700"
        >
            <h1 className="text-3xl sm:text-4xl font-bold mb-6 text-center text-gray-800 px-4 sm:px-6 lg:px-8">
                Disclaimer
            </h1>
            <div className="space-y-6 text-base sm:text-lg px-4 sm:px-6 lg:px-12 py-6 leading-relaxed">
                <p>
                    <a
                        href="https://www.masstortcounsel.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-700 underline hover:text-blue-900 transition"
                    >
                        masstortcounsel.com
                    </a>{' '}
                    is a website dedicated to serving the public as an informational resource, providing accurate content about various medical treatments and associated side effects.{' '}
                    <a
                        href="https://www.masstortcounsel.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-700 underline hover:text-blue-900 transition"
                    >
                        masstortcounsel.com
                    </a>{' '}
                    also connects users with its legal partners, who can evaluate whether an individual has a legal case as a result of side effects or complications caused by a medical treatment.
                </p>

                <p>
                    <a
                        href="https://www.masstortcounsel.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-700 underline hover:text-blue-900 transition"
                    >
                        masstortcounsel.com
                    </a>{' '}
                    is not affiliated with any pharmaceutical companies or drug manufacturers and does not accept advertising or host online advertisements.
                </p>

                <p>
                    There may be times when a visitor comes to{' '}
                    <a
                        href="https://www.masstortcounsel.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-700 underline hover:text-blue-900 transition"
                    >
                        masstortcounsel.com
                    </a>{' '}
                    looking for assistance with a drug or medical device and masstortcounsel determines that visitor would be better served by a trusted outside service provider or law firm. In those cases, the visitor may be contacted directly by that provider or firm.
                </p>

                <h3 className="text-xl font-semibold mt-10 mb-3 text-gray-900">Consent to Contact</h3>
                <p>
                    By submitting a form about a specific drug or medical device, you consent to be contacted by a masstortcounsel representative or a representative from the appropriate service provider. Any information provided to{' '}
                    <a
                        href="https://www.masstortcounsel.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-700 underline hover:text-blue-900 transition"
                    >
                        masstortcounsel.com
                    </a>{' '}
                    will be shared with the service provider. Information provided to{' '}
                    <a
                        href="https://www.masstortcounsel.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-700 underline hover:text-blue-900 transition"
                    >
                        masstortcounsel.com
                    </a>{' '}
                    will not be shared, sold or provided to a data collection company unless specifically authorized.
                </p>

                <h3 className="text-xl font-semibold mt-10 mb-3 text-gray-900">Updated with Latest Information</h3>
                <p>
                    <a
                        href="https://www.masstortcounsel.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-700 underline hover:text-blue-900 transition"
                    >
                        masstortcounsel.com
                    </a>{' '}
                    is continually updated to ensure current information about medications and medical devices and associated side effects is provided to the public. The information on the site is meant to complement a doctor or healthcare professional’s advice and should not be used in place of medical advice. It is important to note that most, if not all, drugs or medical devices discussed on{' '}
                    <a
                        href="https://www.masstortcounsel.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-700 underline hover:text-blue-900 transition"
                    >
                        masstortcounsel.com
                    </a>{' '}
                    are FDA approved.
                </p>

                <p>
                    Content found on{' '}
                    <a
                        href="https://www.masstortcounsel.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-700 underline hover:text-blue-900 transition"
                    >
                        masstortcounsel.com
                    </a>{' '}
                    should not be taken as medical advice and site visitors are encouraged to speak with a medical professional for medical treatment, information and recommendations. Furthermore, site visitors should not discontinue use of a drug or medical device without first seeking the advice of medical professional.
                </p>

                <p>
                    Additionally, the legal information on{' '}
                    <a
                        href="https://www.masstortcounsel.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-700 underline hover:text-blue-900 transition"
                    >
                        masstortcounsel.com
                    </a>{' '}
                    should not be taken as legal advice, as the content on the site is meant to provide general legal information and is not intended to provide information about a specific visitor’s situation. The information on{' '}
                    <a
                        href="https://www.masstortcounsel.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-700 underline hover:text-blue-900 transition"
                    >
                        masstortcounsel.com
                    </a>{' '}
                    is not an offer to create an attorney-client relationship or perform legal services. Visitors should not act or refrain from acting due to information found on this site without the guidance of a qualified and licensed attorney.
                </p>
            </div>
        </div>
    );
}

export default Disclaimer;
